import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fullscreen: false
  },
  mutations: {
    makeFullscreen(state) {
      state.fullscreen = true;
    },
    undoFullscreen(state) {
      state.fullscreen = false;
    }
  },
  actions: {

  }
})
